import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Siren } from "lucide-react";

const SOSButton = () => {
  const navigate = useNavigate();

  return (
    <motion.button
      onClick={() => navigate("/emergency")}
      className="fixed bottom-24 right-4 z-50 w-14 h-14 bg-gradient-to-br from-red-500 to-red-600 rounded-full flex items-center justify-center shadow-xl shadow-red-500/30"
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      animate={{ 
        boxShadow: [
          "0 0 20px rgba(239, 68, 68, 0.3)",
          "0 0 30px rgba(239, 68, 68, 0.5)",
          "0 0 20px rgba(239, 68, 68, 0.3)",
        ]
      }}
      transition={{ 
        boxShadow: { duration: 2, repeat: Infinity }
      }}
      data-testid="sos-button"
    >
      <Siren className="w-6 h-6 text-white" />
    </motion.button>
  );
};

export default SOSButton;
